import {Inject, Injectable} from '@angular/core';
import {API_URL, QueryParam, Utils,Literales} from "lib-base";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class LiteralesService {

  private baseUrl: string ;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/literales`;
  }

  getBySeccion(seccion: string): Observable<Literales[]> {
    const params: QueryParam[] = [{key: 'seccion', value: seccion}];
    return this.http.get<Literales[]>(Utils.createQueryParams(`${this.baseUrl}/public/literales-by-seccion`, params))
  }

}
